import { bool, func, number, oneOf, oneOfType, string } from 'prop-types'
import { useId, useMemo } from 'react'
import styled from 'styled-components'
const StyledCheckbox = styled.label`
	align-items: center;
	border-radius: 8px;
	display: flex;
	font-size: 13px;
	&[data-size='large'] {
		border-radius: 10px;
		& .checkbox-content {
			width: 28px;
			height: 28px;
			border-radius: 10px;
		}
	}
	&[data-size='small'] {
		border-radius: 6px;
		& .checkbox-content {
			width: 20px;
			height: 20px;
			border-radius: 6px;
		}
	}
	& input {
		border: none;
		height: 0px;
		overflow: hidden;
		padding: 0;
		position: absolute;
		white-space: nowrap;
		width: 0px;
		& + .checkbox-content {
			background-color: #ffffff;
			border: 1.5px solid #e1e1e1;
			fill: #ffffff;
			stroke: #ffffff;
		}
		&:checked {
			& + .checkbox-content {
				background-color: #018ecc;
				border: 1.5px solid #018ecc;
				fill: #018ecc;
				stroke: #f2f2f2;
			}
		}
		.dark & {
			& + .checkbox-content {
				background-color: #2e2d2d;
				border: 1.5px solid #555555;
				fill: #2e2d2d;
				stroke: #2e2d2d;
			}
			&:checked + .checkbox-content {
				background-color: #018ecc;
				border: 1.5px solid #018ecc;
				fill: #018ecc;
				stroke: #f2f2f2;
			}
		}
		&:disabled + .checkbox-content {
			cursor: default;
		}
	}
	& .checkbox-content {
		align-items: center;
		border-radius: 8px;
		cursor: pointer;
		display: inline-flex;
		height: 24px;
		justify-content: center;
		position: relative;
		transition: 200ms;
		width: 24px;
		& svg {
			flex-shrink: 0;
		}
	}
`
const CheckboxInput = ({
	'data-cy': dataCY,
	id: innerId = '',
	isDisabled = false,
	onChange,
	ref,
	size = 'medium',
	value = false,
}) => {
	const id = useId()
	const inputId = useMemo(() => innerId || id, [innerId, id])
	return (
		<StyledCheckbox data-size={size} htmlFor={inputId}>
			<input
				checked={value}
				data-cy={dataCY}
				disabled={isDisabled}
				id={inputId}
				ref={ref}
				type='checkbox'
				onChange={() => {
					if (!isDisabled) {
						onChange(!value)
					}
				}}
			/>
			<span className='checkbox-content'>
				<svg height='24' viewBox='0 0 20 20' width='24'>
					<path
						d='M14 7L8.5 12.5L6 10'
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth='2'
					/>
				</svg>
			</span>
		</StyledCheckbox>
	)
}
CheckboxInput.propTypes = {
	'data-cy': string,
	id: oneOfType([string, number]),
	isDisabled: bool,
	onChange: func,
	size: oneOf(['large', 'medium', 'small']),
	value: bool,
}
export default CheckboxInput
